import { render, staticRenderFns } from "./FaqHomeRtl.vue?vue&type=template&id=095de268&"
import script from "./FaqHomeRtl.vue?vue&type=script&lang=js&"
export * from "./FaqHomeRtl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports